<template>
  <!-- <PullRefresh v-model="refreshing" @refresh="onRefresh"> -->
  <List
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <ul class="cell-wrap">
      <template v-if="list.length">
        <li v-for="data in list" :key="data.id">
          <p class="cell-title">
            <span></span
            ><span class="cell-title-time">{{ data.createTimeString }}</span>
          </p>
          <p v-if="type !== 3" class="cell-content">
            {{ data.answerContent }}
          </p>
          <div v-else>
            <div
              v-for="(file, index) in formatFileList(data.answerContent)
                .fileList"
            >
              <a class="file-wrap" :href="file.url" download="">
                <p>
                  {{ file.name }}
                </p>
                <Icon color="#333333" name="arrow" size="18"
              /></a>
            </div>
            <div class="img-list">
              <img
                v-for="(img, index) in formatFileList(data.answerContent)
                  .imgList"
                class="detail-img"
                @click="
                  handleImgPreview(
                    formatFileList(data.answerContent).imgList,
                    index
                  )
                "
                :src="img.url"
                alt=""
              />
            </div>
          </div>
        </li>
      </template>
      <template v-else>
        <p v-if="!loading" class="no-data-text">暂无数据</p>
      </template>
    </ul>
  </List>
  <!-- </PullRefresh> -->
</template>

<script setup>
import { onMounted, ref, watch, watchEffect } from 'vue'
import { List, PullRefresh, ImagePreview, Icon } from 'vant'
import axios from 'axios'
import { getAnswerRecordBlank } from '@/api/admin'
import { isImage } from '@/utils/tools'

const props = defineProps({
  optionKey: {
    type: String,
    default: '',
  },
  type: {
    type: Number,
    default: '',
  },
  formDate: Object,
})

const list = ref([])
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)

const formatFileList = (str) => {
  try {
    const list = JSON.parse(str)

    const imgList = list.filter((item) => isImage(item.url))
    const fileList = list.filter((item) => !isImage(item.url))

    return {
      imgList,
      fileList,
    }
  } catch (error) {
    return {
      imgList: [],
      fileList: [],
    }
  }
}

const handleImgPreview = (list, startPosition) => {
  const images = list.map((item) => item.url)
  ImagePreview({
    images,
    startPosition,
  })
}

const fetchData = async () => {
  loading.value = true
  try {
    const { data } = await getAnswerRecordBlank({
      optionKey: props.optionKey,
      ...props.formDate,
      offset: 1,
      pageSize: 999,
    })
    if (refreshing.value) {
      list.value = data.data.rows
      refreshing.value = false
    } else {
      list.value.push(...data.rows)
    }

    loading.value = false

    if (list.value.length >= data.total) {
      finished.value = true
    }
  } catch (error) {
    loading.value = false
  }
}

const onRefresh = () => {
  finished.value = false
  refreshing.value = true
  list.value = []
  fetchData()
}

const onLoad = () => {
  if (finished.value || loading.value) {
    return
  }
  fetchData()
}

watch(
  () => props.optionKey,
  (n, o) => {
    if (n === o) return
    finished.value = false
  }
)

watchEffect(() => {
  list.value = []
  fetchData()
})
</script>
<style lang="scss" scoped>
.cell-wrap {
  padding: 30px;
  min-height: 50vh;

  .cell-loading {
    text-align: center;
  }

  .cell-title {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 32px;
    line-height: 1.2;

    span.cell-title-time {
      display: inline-block;
      min-width: 200px;
      text-align: right;
      font-size: 24px;
      color: #999;
    }
  }

  .cell-content {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    font-size: 28px;
    color: #888;
    line-height: 1.4;
  }

  .file-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin: 10px auto;
    width: 700px;
    padding: 20px 18px;
    color: #333;
    font-size: 28px;
    color: #555555;
    box-shadow: 0px 2px 15px 0px rgba(130, 130, 130, 0.22);
    border-radius: 10px;

    p {
      line-height: 1.5;
    }
  }

  .img-list {
    display: flex;
    flex-wrap: wrap;
    .detail-img {
      margin-left: 10px;
      margin-bottom: 10px;
      width: 157px;
      height: 157px;
      object-fit: cover;
    }
  }

  .no-data-text {
    font-size: 30px;
    text-align: center;
  }
}
</style>
